<template>
  <congratulation v-bind="$attrs" v-on="$listeners" v-slot="{ close }">
    <validation-observer v-slot="{ handleSubmit }">
      <v-container
        class="position-relative"
        v-if="$attrs.template === 'congratulations-employee'"
      >
        <img
          :src="iconClose"
          height="50"
          width="50"
          alt=""
          class="position-absolute top-8 right-8 cursor-pointer"
          @click="close"
        />
        <v-row class="congratulation__info_user">
          <v-col class="text-center text-color--black">
            <v-avatar size="70" class="avatar">
              <img :src="$attrs.receiver.avatar" :alt="$attrs.receiver.name" />
            </v-avatar>
            <span class="name">{{ $attrs.receiver.abbreviateName }}</span>
          </v-col>
        </v-row>
        <v-row class="congratulation__content">
          <v-col class="text-center">
            <span>{{ $attrs.comment }}</span>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else class="other position-relative">
        <img
          :src="iconClose"
          height="50"
          width="50"
          alt=""
          class="position-absolute top-8 right-8 cursor-pointer"
          @click="close"
        />
        <v-row class="congratulation__info_user">
          <v-col class="text-center text-color--black">
            <v-avatar size="60" class="avatar">
              <img :src="$attrs.receiver.avatar" alt="John" />
            </v-avatar>
            <span class="name">{{ $attrs.receiver.abbreviateName }}</span>
          </v-col>
        </v-row>
        <v-row class="congratulation__content mt-1" no-gutters>
          <v-col class="text-center">
            <span>{{ $attrs.comment }}</span>
          </v-col>
        </v-row>
        <v-row class="congratulation__comment mt-3" no-gutters>
          <v-col>
            <validation-provider
              :name="$t('common.message')"
              rules="required"
              v-slot="{ errors }"
            >
              <v-textarea
                outlined
                color="black"
                :label="$t('common.message')"
                :placeholder="$t('common.message')"
                v-model="messageData.message"
                :error-messages="errors"
                rows="2"
                class="text_area"
                hide-details
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="congratulation__point mt-3" no-gutters>
          <v-col class="d-flex justify-space-between select-point">
            <v-select
              v-model="giftPoint"
              hide-details
              color="black"
              :items="listPoint"
              :label="$t('common.selectNumberOfPointsToSend')"
              item-value="value"
              item-text="text"
              outlined
              dense
              id="mySelect"
            />
          </v-col>
        </v-row>
        <v-row class="congratulation__action send_point" no-gutters>
          <v-col class="text-center mt-5">
            <v-btn
              class="send_point__btn"
              @click="handleSubmit(() => save(close))"
            >
              {{ $t('common.sendPoint') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </validation-observer>
  </congratulation>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import iconClose from '@/assets/icons/close-2.png';
import * as numeral from 'numeral';
import Congratulation from './Congratulation.vue';

export default {
  name: 'CongratulationsEmployee',
  components: { Congratulation },
  data: () => ({
    sentGift: false,
    loading: false,
    chooseBtnIndex: -1,
    giftPoint: 0,
    messageData: {
      point: undefined,
      message: undefined,
      categoryId: undefined,
    },
    iconClose,
  }),
  computed: {
    ...mapGetters('gift', ['categoryItems']),
    ...mapGetters('staff', ['currentStaff']),
    listPoint() {
      const points = this.currentStaff.defaultGiftPoint.map((p) => {
        const item = {
          value: p,
          text: numeral(p).format('0,0'),
        };
        return item;
      });
      points.unshift({
        value: null,
        text: '0',
      });
      return points;
    },
  },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
    async save(callback) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const gift = {
          ...this.messageData,
          gift: this.giftPoint,
          staffToId: this.$attrs.receiver.id,
        };
        await this.$APIBuilder.store('gift').createOne(gift);
        this.message = '';
        this.giftCategory = undefined;
        await this.$cheeers.notify({
          text: this.$t('give.action.success'),
        });
        this.sentGift = true;
        callback();
      } catch (e) {
        await this.$cheeers.notify({
          text: this.$t('give.action.fail'),
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass">
.select-point
  .v-input__slot fieldset
    background-color: #efcc55 !important
.congratulation
  box-shadow: none !important
  .theme--dark.v-label, .v-select__selection--comma
    color: black !important
  .v-input__slot fieldset
    color: #f68f3c !important
    border: 3px solid
  .v-icon
    color: #f68f3c !important
  .main-card
    background-image: url("../../../../assets/image/notification/template/congratulation.png")
    position: relative
    background-color: transparent !important
    box-shadow: none !important
    border-color: unset !important
    background-size: contain !important
  &__comment
    width: 50%
    margin: auto !important
    .text_area
      .v-label
        color: black
      fieldset
        border: 2px solid
        color: black !important
      &.error--text
        fieldset
          color: red !important
    .v-input
      color: black
  &__info_user
    margin-top: 150px
    color: black
    & > div
      display: flex
      justify-content: center
      align-items: center
      .avatar
        border: 5px solid black
      .name
        margin-left: 20px
        font-weight: bold
        font-size: 2.2rem
        line-height: 70px
        max-width: 350px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
  &__content
    margin: auto
    width: 50%
    height: 180px
    max-height: 180px
    span
      color: black
      font-size: 1.2rem
      font-weight: 500
  &__action
    .btn_action
      background-color: transparent !important
      color: #848282
      border: 1px solid #d4d4d4
      border-radius: 20px
      padding: 0px 30px !important
      font-weight: bold
      font-size: 1rem
.other
  .congratulation
    &__content
      margin: auto
      width: 50%
      height: auto
      max-height: 60px
    &__point
      margin: auto
      width: 45%
      color: black
    &__info_user
      margin-top: 120px
      color: black
      .name
        font-size: 1.6rem
        max-width: 250px
        white-space: nowrap
    &__content
      span
        font-size: 1rem
    &__action
      &.send_point
        .send_point__btn
          background-color: #f68f3c !important
          border-radius: 25px
          height: 30px
          line-height: 30px
          padding: 2px 20px !important
          position: relative
          font-weight: bold
          max-width: 160px
          width: 160px
          span
            margin-top: 2px !important
          &::after
            content: ''
            position: absolute
            width: 170px
            left: -5px
            top: -5px
            border-radius: 25px
            border: 1px solid #f68f3c
            height: 41px
</style>
